import PageHeader from '../components/PageHeader';
import secondHeader from '../assets/images/secondHeader.png';
import timeBG from '../assets/images/timeBG.png';
import generalAvatar from '../assets/images/generalAvatar.png'
import hammerAvatar from '../assets/images/hammerAvatar.png'
import hatAvatar from '../assets/images/hatAvatar.png'
import AnimatedSection, { AnimatedGroup, AnimatedItem } from '../components/AnimatedSection';

const Committee = () => {
    return (
        <>
            <PageHeader image={secondHeader} title="لجنة المؤتمر" />

            <div className="w-full bg-white bg-contain py-16 px-6 md:py-20 " style={{ backgroundImage: `url(${timeBG})` }}>
                <div className='max-w-[1084px] mx-auto'>
                
                    <AnimatedSection as="section">
                        <h2 className="text-[34px] md:text-[42px] font-normal mb-6"> اللجنة العلمية للمؤتمر </h2>
                        
                        <AnimatedGroup className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <AnimatedItem className="md:col-span-2 flex items-center md:gap-14 gap-4 md:pr-24 pr-4  p-6 bg-white border border-gray-200 rounded-xl shadow-[0px_0px_6.04px_0.88px_#00000040]">
                                <div className="flex-shrink-0 ml-4">
                                    <img src={generalAvatar} alt="generalAvatar" className="w-14 h-14" />
                                </div>
                                <div className="md:pr-8 pr-4 sm:pr-0">
                                    <h3 className="md:text-[32px] text-[22px] font-bold text-[#3E82B9] mb-1">رئيس اللجنة الاشرافية للمؤتمر</h3>
                                    <p className="text-[#031246] md:text-2xl text-[18px] font-normal">د. نوره بنت عبد الرزاق الدرع</p>
                                </div>
                            </AnimatedItem>

                            <AnimatedItem className="md:col-span-2 flex items-center md:pr-24 pr-4 md:gap-14 gap-4  p-6 bg-white border border-gray-200 rounded-xl shadow-[0px_0px_6.04px_0.88px_#00000040]">
                                <div className="flex-shrink-0 ml-4">
                                    <img src={generalAvatar} alt="generalAvatar" className="w-14 h-14" />
                                </div>
                                <div className="md:pr-8 pr-4 sm:pr-0">
                                <h3 className="md:text-[32px] text-[22px] font-bold text-[#32749f] mb-1">رئيس اللجنة التنفيذية</h3>
                                <p className="text-[#031246] md:text-2xl text-[18px] font-normal">د. أصايل بنت أحمد العوهلي</p>
                                </div>
                            </AnimatedItem>

                        <AnimatedItem className="col-span-1 flex items-center p-6 bg-white border border-gray-200 rounded-xl shadow-[0px_0px_6.04px_0.88px_#00000040]">
                            <div className="flex-shrink-0 ml-4">
                                <img src={hammerAvatar} alt="hammerAvatar" className="w-14 h-14" />
                            </div>
                            <div className="md:pr-8 pr-4 sm:pr-0">
                                <h3 className="md:text-[32px] text-[22px] font-bold text-[#3E82B9] mb-1">الدكتور</h3>
                                <p className="text-[#031246] md:text-2xl text-[18px] font-normal">عبدالرحمن بن نبيل الصالح ( عضو )</p>
                            </div>
                        </AnimatedItem>

                        <AnimatedItem className="col-span-1 flex items-center p-6 bg-white border border-gray-200 rounded-xl shadow-[0px_0px_6.04px_0.88px_#00000040]">
                            <div className="flex-shrink-0 ml-4">
                                <img src={hammerAvatar} alt="hammerAvatar" className="w-14 h-14" />
                            </div>
                            <div className="md:pr-8 pr-4 sm:pr-0">
                                <h3 className="md:text-[32px] text-[22px] font-bold text-[#3E82B9] mb-1">الدكتور</h3>
                                <p className="text-[#031246] md:text-2xl text-[18px] font-normal">خالد بن سامي السدحان ( عضو )</p>
                            </div>
                        </AnimatedItem>
                        </AnimatedGroup>
                    </AnimatedSection>

                    <AnimatedSection as="section" className='mt-16'>
                        <h2 className="text-[42px] font-normal mb-6">
                        اللجنه التنظيمية واللوجستية
                        </h2>
                        
                        <AnimatedGroup className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <AnimatedItem className="md:col-span-2 flex items-center md:pr-24 pr-4 md:gap-14 gap-4 p-6 bg-white border border-gray-200 rounded-xl shadow-[0px_0px_6.04px_0.88px_#00000040]">
                            <div className="flex-shrink-0 ml-4">
                                <img src={generalAvatar} alt="generalAvatar" className="w-14 h-14" />
                            </div>
                            <div className="md:pr-8 pr-4 sm:pr-0">
                            <h3 className="md:text-[32px] text-[22px] font-bold text-[#3E82B9] mb-1">رئيس وحدة العلاقات العامة والإعلام بالكلية</h3>
                            <p className="text-[#031246] md:text-2xl text-[18px] font-normal">أ. وليد بن مبارك الدوسري</p>
                            </div>
                        </AnimatedItem>

                        <AnimatedItem className="col-span-1 flex items-center p-6 bg-white border border-gray-200 rounded-xl shadow-[0px_0px_6.04px_0.88px_#00000040]">
                            <div className="flex-shrink-0 ml-4">
                                <img src={generalAvatar} alt="hammerAvatar" className="w-14 h-14" />
                            </div>
                            <div className="md:pr-8 pr-4 sm:pr-0">
                            <p className="text-[#031246] md:text-2xl text-[18px] font-normal">أ. خالد بن سعد بن عبيد ( عضو )</p>
                            </div>
                        </AnimatedItem>

                        <AnimatedItem className="col-span-1 flex items-center p-6 bg-white border border-gray-200 rounded-xl shadow-[0px_0px_6.04px_0.88px_#00000040]">
                            <div className="flex-shrink-0 ml-4">
                                <img src={generalAvatar} alt="hammerAvatar" className="w-14 h-14" />
                            </div>
                            <div className="md:pr-8 pr-4 sm:pr-0">
                            <p className="text-[#031246] md:text-2xl text-[18px] font-normal">أ. فدى بنت محمد الوعلان ( عضو )</p>
                            </div>
                        </AnimatedItem>

                        <AnimatedItem className="md:col-span-2 flex items-center md:pr-24 pr-4 md:gap-14 gap-4 p-6 bg-white border border-gray-200 rounded-xl shadow-[0px_0px_6.04px_0.88px_#00000040]">
                            <div className="flex-shrink-0 ml-4">
                                <img src={hatAvatar} alt="generalAvatar" className="w-14 h-14" />
                            </div>
                            <div className="md:pr-8 pr-4 sm:pr-0">
                            <p className="text-[#031246] md:text-2xl text-[18px] font-normal">إبراهيم أحمد الغميز ( عضو - طالب )</p>
                            </div>
                        </AnimatedItem>
                        </AnimatedGroup>
                    </AnimatedSection>

                </div>
            </div>
        </>
    );
};

export default Committee;
